import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';
import { DropdownTrigger as _DropdownTrigger } from '@hrworks/sui-shared/components';

const componentConfig = {
  profileMenuSize: 46,
};

const DropdownTrigger = styled(_DropdownTrigger)(({ theme }) => ({
  display: 'flex',
  verticalAlign: 'top',
  width: componentConfig.profileMenuSize,
  height: componentConfig.profileMenuSize,
  borderRadius: theme.eclipseTier1.radius['9999px'],
}));

const Arrow = styled.div(({ theme }) => ({
  display: 'block',
  overflow: 'hidden',
  width: 20,
  height: 10,
  '&::before': {
    content: '""',
    display: 'block',
    border: '10px solid transparent',
    borderTopColor: theme.eclipseTier2Color.background.brand.bold.default,
  },
}));

const Container = styled.div(({ theme }) => ({
  boxShadow: theme.eclipseTier2Color.surface.elevation.shadow.overlay.boxShadow,
  width: 325,
  borderRadius: theme.eclipseTier1.radius['12px'],
  overflow: 'hidden',
}));

const components = { DropdownTrigger, Arrow, Container };

export const S = {
  ...components,
  ...createClassNames('ProfileMenu', components),
} as const;
